import {CATEGORIAS_DORE, ETIQUETA_CATEGORIA_DORE, ETIQUETA_CATEGORIA_DORE_EN} from '@cnc/contracts';
import {RAIZ_DE_DORE, useArchivosDeExportacion} from '../api/carpetas';
import {rutaDelZipDelExpediente} from '../api/documentos';
import {
  rutaDeLaVistaDore,
  rutaDelDocumentoDore,
  useBorrarDelExpedienteDore,
  useExpedienteDore,
  useSubirAlExpedienteDore,
} from '../api/dore-carpetas';
import {et} from '../i18n/idioma';
import {Explorador} from './archivos-de-exportacion';
import {CarpetaEnDropbox} from './carpeta-en-dropbox';
import {VistaDeExpediente} from './expediente';

// La carpeta de Dropbox y el expediente de una exportacion de dore en una sola
// vista, como en concentrados (decision 0095). Sin Dropbox, solo el expediente.
export function DocumentosDeDore({codigo}: {codigo: string}) {
  const consulta = useArchivosDeExportacion(codigo, RAIZ_DE_DORE);
  const expediente = useExpedienteDore(codigo);
  const subir = useSubirAlExpedienteDore(codigo);
  const borrar = useBorrarDelExpedienteDore(codigo);
  const etiquetas = et(ETIQUETA_CATEGORIA_DORE, ETIQUETA_CATEGORIA_DORE_EN);
  const documentos = expediente.data?.documentos ?? [];
  const d = consulta.data;
  const conCarpeta = !!d?.disponible;
  const enDropbox = new Set((d?.archivos ?? []).map(a => `${a.nombre.toLowerCase()}|${a.bytes}`));
  const visibles = conCarpeta
    ? documentos.filter(x => !enDropbox.has(`${x.nombre.toLowerCase()}|${x.tamanoBytes}`))
    : documentos;
  return (
    <>
      {d && conCarpeta ? (
        <Explorador
          codigo={codigo}
          datos={d}
          recargar={() => void consulta.refetch()}
          cargando={consulta.isFetching}
          raiz={RAIZ_DE_DORE}
          area="dore"
        />
      ) : (
        <>
          <CarpetaEnDropbox codigo={codigo} raiz={RAIZ_DE_DORE} area="dore" />
          {d?.error && <p className="text-sm text-alerta">{d.error}</p>}
        </>
      )}
      <VistaDeExpediente
        documentos={visibles}
        soloEnLaApp={conCarpeta}
        total={documentos.length}
        categorias={CATEGORIAS_DORE.map(c => ({valor: c, etiqueta: etiquetas[c]}))}
        subiendo={subir.isPending}
        borrando={borrar.isPending}
        subir={(archivo, categoria) => subir.mutateAsync({archivo, categoria})}
        borrar={id => borrar.mutateAsync(id)}
        rutaDelDocumento={rutaDelDocumentoDore}
        rutaDeLaVista={rutaDeLaVistaDore}
        rutaDelZip={rutaDelZipDelExpediente(codigo, RAIZ_DE_DORE)}
      />
    </>
  );
}
